// extracted by mini-css-extract-plugin
module.exports = {"root":"Principle_root__1gIqb","title":"Principle_title__gRqsv","subtitle":"Principle_subtitle__SmwX7"};